module.exports = __webpack_public_path__ + "img/rightTab001.svg";